module.exports = __webpack_public_path__ + "img/twitter.8e290ed8.svg";